import React from "react";
import { useLocation } from "react-router-dom";
import adminRoutes from "adminRoutes.js";
import ThemeToggle from "components/ThemeToggle";
import styles from "./DemoNavbar.module.css";

function AdminHeader(props) {
  const location = useLocation();
  const sidebarToggle = React.useRef();

  const getBrand = () => {
    let brandName = "Admin Panel";
    adminRoutes.forEach((prop) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
    });
    return brandName;
  };

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.left}>
        {/* Sidebar toggle (mobile) */}
        <button
          type="button"
          ref={sidebarToggle}
          className={styles.hamburger}
          onClick={openSidebar}
          aria-label="Toggle sidebar"
        >
          <span />
          <span />
          <span />
        </button>

        {/* Page title */}
        <span className={styles.brand}>{getBrand()}</span>
      </div>

      <div className={styles.right}>
        <ThemeToggle />

        <div className={styles.userArea}>
          <span className={styles.brand} style={{ color: "var(--accent)", fontSize: "0.8rem", letterSpacing: "0.04em" }}>
            ADMIN
          </span>
        </div>
      </div>
    </nav>
  );
}

export default AdminHeader;